<template>
  <DocumentUploadDialog
    v-model:show-drawer="showUploadDrawer.show"
    v-model:existing-document="showUploadDrawer.existingDocument"
    v-model:edit-mode="showUploadDrawer.editMode"
    :application-id="applicationId"
    @upload-document-success="
      () => {
        showUploadDrawer.editMode = false
        showUploadDrawer.existingDocument = null
        updateTable()
      }
    "
    @download-document="(document: DocumentInfo) => getDocument(document)" />

  <el-card
    style="height: 100%; width: 100%"
    body-class="flex flex-col gap-4"
    :body-style="{
      height: '100%',
      width: '100%',
    }"
    shadow="always">
    <div class="flex items-center gap-2 pb-4 pt-2">
      <div>
        <SmInput
          v-model="searchQuery"
          style="width: 250px; margin-right: 1px"
          size="small"
          outline
          :label="i18n.t('search')" />
      </div>
      <el-date-picker
        v-model="selectedDateRange"
        type="monthrange"
        range-separator="-"
        :start-placeholder="i18n.t('views.documents.dateRange.from')"
        :end-placeholder="i18n.t('views.documents.dateRange.to')"
        format="MMM. YYYY"
        class="rounded-lg border border-contrast !shadow-none"
        style="max-width: 300px" />
      <SmButton
        v-require-permission="CompanyAccessRole.ADMIN"
        class="ml-auto"
        @click="showUploadDrawer.show = true">
        {{ i18n.t('views.documents.addDocument') }}
      </SmButton>
    </div>
  <BaseSoftwareDocumentTable
      :key="tableKey"
      v-model:search-query="searchQuery"
      v-model:selected-date-range="selectedDateRange"
      view-mode
      :application-id="applicationId"
      :small-card-mode="false" />
  </el-card>
</template>

<script setup lang="ts">
  import { computed, ref, watchEffect } from 'vue'
  import { useRoute } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import { CompanyAccessRole } from '@/client'
  import { DocumentInfo } from '@/client'
  import { downloadResource } from '@/utils/download'
  import { useApplicationDetailsStore } from '@/stores/ApplicationDetailsView.store'

  const route = useRoute()
  const i18n = useI18n()
  const applicationDetailsStore = useApplicationDetailsStore()

  const applicationId = computed(() => {
    const param = route.params.id
    return Array.isArray(param) ? param[0] : (param as string)
  })

  watchEffect(() => {
    if (applicationId.value) {
      applicationDetailsStore.loadApplicationDetails(applicationId.value)
    }
  })

  const searchQuery = ref<string>('')
  const selectedDateRange = ref<[string, string]>()

  const tableKey = ref<number>(0)
  const updateTable = () => {
    tableKey.value += 1
  }

  interface ShowUploadDrawer {
    show: boolean
    editMode: boolean
    existingDocument: DocumentInfo | null
  }

  const showUploadDrawer = ref<ShowUploadDrawer>({
    show: false,
    editMode: false,
    existingDocument: null,
  })

  function getDocument(rowDocument: DocumentInfo) {
    downloadResource({ documentId: rowDocument._id }).then((blob) => {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      Object.assign(a, {
        href: url,
        download: rowDocument.filename,
        target: '_blank',
      })
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
    })
  }
</script>
